import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBb1R_99NuUXC2iqDTI5ORHvhUZTqkuYOk",
  authDomain: "clone-ccc3d.firebaseapp.com",
  databaseURL: "https://clone-ccc3d-default-rtdb.firebaseio.com",
  projectId: "clone-ccc3d",
  storageBucket: "clone-ccc3d.appspot.com",
  messagingSenderId: "886438311133",
  appId: "1:886438311133:web:920bf71b6a7fe063be1734",
  measurementId: "G-90MNLYCR14",
};

const app = initializeApp(firebaseConfig);

const db = getFirestore(app);
const auth = getAuth(app);

export { db, auth };
